import { render, staticRenderFns } from "./VInventoryItemMarkBrokenModal.vue?vue&type=template&id=61d3ae06"
import script from "./VInventoryItemMarkBrokenModal.vue?vue&type=script&lang=js"
export * from "./VInventoryItemMarkBrokenModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports